import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { EventEmitter, Input } from '@angular/core';
import { Component, Output } from '@angular/core';
import { IxellAPIService, StatsDropdownValue, StatsGraphFilterKind, StatsKeyfactorKind } from 'src/app/tools/api.service';


@Component({
  selector: 'stats-txt-modal',
  templateUrl: './txt-modal.component.html',
  styleUrls: ['./txt-modal.component.scss']
})

export class StatsTXTModalComponent {
  @Input() text: string;
  @Output() close = new EventEmitter<void>();

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
  }

  doClose() {
    this.close.emit();
  }
}
